// extracted by mini-css-extract-plugin
module.exports = {"root":"CompactCeil_root_13KVn","inner":"CompactCeil_inner_3Mfgz","item":"CompactCeil_item_cGsY5","title":"CompactCeil_title_1VPlU"};